import { Dropdown, Form, Button, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Link, useSearchParams } from "react-router-dom";
import "./../../assets/scss/scoped/invoicelist.scoped.scss";
import useDebounce, { useEffectOnce, useQueryParams } from "../../utils/hooks";
import Select from "react-select";
import CachedIcon from "mdi-react/CachedIcon";
import NewDocumentCertificationModal from "../NewDocumentCertificationModal";
import { queryActions } from "../../utils/reactQueryActions";
import { useMutation, useQuery } from "react-query";
import queryString from "query-string";
import { useStoreActions, useStoreState } from "easy-peasy";
import { services } from "../../config";
import {
  customerFullName,
  documentTypeOptions,
  customerTypeOptions,
  paginationOptions,
  searchParamsToObject,
} from "../../utils/helpers";
import { useAuth } from "../../hooks/useAuth";
import ReactPaginate from "react-paginate";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
// import SetSalesRepModal from "./SetSalesRepModal";
import { format } from "date-fns";
import currency from "currency.js";
import {
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  FileListIcon,
  ViewIcon,
  QuotationIcon,
} from "../Icons";
import EditDocumentCertificationModal from "../EditDocumentCertificationModal";
import { toast } from "react-toastify";
import ModalLoader from "../utils/ModalLoader";
import ConfirmDialog from "../ConfirmDialogue";
import NoTableItem from "./../utils/NoTableItem";

export default function DocumentsCertification() {
  const [searchParams] = useSearchParams();
  const { backendUrl, token } = useAuth();
  const [
    showNewDocumentCertificationModal,
    setShowNewDocumentCertificationModal,
  ] = useState(false);
  const [
    showEditDocumentCertificationModal,
    setShowEditDocumentCertificationModal,
  ] = useState(false);

  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showSalesRepManager, setShowSalesRepManager] = useState(null);

  const initialFilterParams = { q: "", page: 1, limit: 40 };

  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const debouncedFilterParams = useDebounce(filterParams, 500);

  const generalSettings = useStoreState((state) => state.generalSettings);

  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  // action form url query on render once
  useEffectOnce(() => {
    const queryParams = searchParamsToObject(searchParams.entries());
    if (queryParams?.action === "create") {
      setShowNewDocumentCertificationModal(true);
      // delete queryParams.action;
      setQueryParams({ ...initialFilterParams });
    }
  });

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
    });
  };

  const getDocument = async (debouncedqueryParams) => {
    let response = await fetch(
      `${backendUrl}/api/document?${queryString.stringify(
        debouncedqueryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    return data;
  };

  const { data = { documents: [] }, refetch } = useQuery(
    [queryActions.DOCUMENTS, queryParams],
    () => getDocument(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const deleteDocument = async (payload) => {
    let response = await fetch(`${backendUrl}/api/document/delete`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteDocumentMutation = useMutation(
    (payload) => deleteDocument(payload),
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        refetch();
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const editDocument = (document) => {
    setSelectedDocument(document);
    setShowEditDocumentCertificationModal(true);
  };

  const handlefedeleteDocument = async (document) => {
    if (
      await ConfirmDialog({
        title: "Delete Document",
        description: `Are you sure, you want to delete ${document.Name}?`,
      })
    ) {
      deleteDocumentMutation.mutate(document);
    }
  };

  const handleDownloadFile = async (documentItem) => {
    const link = document.createElement("a");
    link.href = `${backendUrl}/api/document/file/download/${
      documentItem.NewFileName
    }`;
    link.setAttribute("download", documentItem.origFileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <main className="bg-white">
      <header className="p-4">
        <div className="search-area d-flex flex-wrap justify-content-between gap-3 w-100">
          <div className="d-flex flex-wrap gap-3">
            <Button
              variant="primary"
              showNewDocumentCertificationModal
              onClick={() => setShowNewDocumentCertificationModal(true)}
            >
              + New Document / Certification
            </Button>

            <div className="d-flex flex-wrap gap-3">
              <div className="global-search-area">
                <MagnifyIcon />
                <Form.Control
                  id="queryParams-q"
                  className=""
                  name="Name"
                  value={filterParams.Name}
                  onChange={(e) => handleSearchQueryChange(e)}
                  placeholder="Search..."
                />
              </div>
              <Button
                onClick={() => refetch()}
                variant=""
                className="bg-light-blue border-0 text-primary"
              >
                <CachedIcon />
              </Button>
            </div>
          </div>

          <div
            className="d-flex flex-wrap gap-3"
            style={{ fontSize: "0.875rem" }}
          >
            <Form.Group>
              <Select
                classNamePrefix="form-select"
                menuPosition="fixed"
                menuPlacement="auto"
                placeholder="Type of Document"
                name="TransType"
                isSearchable={true}
                onChange={(selected) => {
                  setFilterParams({
                    ...filterParams,
                    TransType: selected.value,
                  });
                }}
                value={documentTypeOptions.find(
                  (el) => el.value === filterParams.TransType
                )}
                options={documentTypeOptions || []}
              />
            </Form.Group>
          </div>
        </div>
      </header>

      <div className="content px-4 pb-4">
        <Table borderless striped responsive className="product-table">
          <thead className="sticky border-bottom">
            <tr>
              <th>Name</th>
              <th>File Name</th>
              <th>Type of Document</th>
              <th>Created By</th>
              <th>Expiry Date</th>
              <th>Comment</th>
              <th>Date Created</th>
            </tr>
          </thead>

          <tbody className="blue-hover">
            {data.documents &&
              data.documents.map((el, index) => (
                <tr key={index}>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="bg-white border-0"
                        bsPrefix="print more"
                      >
                        <DotsVerticalIcon />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="dropdown-with-icons"
                      >
                        <Dropdown.Item
                          onClick={() => editDocument(el)}
                          as="button"
                        >
                          <EditIcon />
                          Edit Document
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleDownloadFile(el)}
                          as="button"
                        >
                          <DownloadIcon />
                          Download File
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handlefedeleteDocument(el)}
                          as="button"
                        >
                          <DeleteIcon />
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>{" "}
                    </Dropdown>
                  </td>
                  <td>{el.Name}</td>
                  <td>{el.DocType}</td>
                  <td>{el.CreatorName}</td>
                  <td>{el.ExpiryDate}</td>
                  <td>{el.Comment ? el.Comment : "---"}</td>
                  <td>{el.DateCreated}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {data.documents.length < 1 ? (
          <div className="d-flex justify-content-center text-center w-100 my-4">
            <NoTableItem queryParams={queryParams} />
          </div>
        ) : null}
      </div>

      <div className="d-flex justify-content-between px-4 align-items-center pagination pb-4 ">
        {/*<p className="m-0">
                Showing {data?.startIndex + 1} to{" "}
                {data?.endIndex <= data?.count ? data?.endIndex : data?.count}{" "}
                of {data.count} entries
                  </p> */}
        <div className="pagination_left d-flex gap-3 align-items-center">
          <p className="m-0 p-0">Show</p>
          <select
            value={queryParams.limit}
            name="limit"
            className="form-select "
            onChange={(e) => handleSearchQueryChange(e)}
          >
            <option value="10">10 rows</option>
            <option value="20">20 rows</option>
            <option value="30">30 rows</option>
            <option value="40">40 rows</option>
          </select>
        </div>

        <ReactPaginate
          {...paginationOptions}
          pageCount={Math.ceil(data.count / queryParams.limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={0}
          onPageChange={({ selected }) => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            setQueryParams({
              ...queryParams,
              page: selected + 1,
            });
          }}
          forcePage={queryParams.page - 1}
        />
      </div>

      {showNewDocumentCertificationModal && (
        <NewDocumentCertificationModal
          showNewDocumentCertificationModal={showNewDocumentCertificationModal}
          setShowNewDocumentCertificationModal={
            setShowNewDocumentCertificationModal
          }
          refetch={refetch}
        />
      )}

      {showEditDocumentCertificationModal && selectedDocument ? (
        <EditDocumentCertificationModal
          showEditDocumentCertificationModal={
            showEditDocumentCertificationModal
          }
          setShowEditDocumentCertificationModal={
            setShowEditDocumentCertificationModal
          }
          selectedDocument={selectedDocument}
          setSelectedDocument={setSelectedDocument}
          refetch={refetch}
        />
      ) : null}

      {/* {showSalesRepManager && selectedCustomer ? (
        <SetSalesRepModal
          selectedCustomer={selectedCustomer}
          setSelectedDocument={setSelectedDocument}
          setShowSaleRepModal={setShowSalesRepManager}
        />
      ) : null} */}

      <ModalLoader show={deleteDocumentMutation.isLoading} />
    </main>
  );
}
